module.exports = __webpack_public_path__ + "img/img-fastspin.228a659f.png";